module Client.Home


// open Client
// open Client.Services
open Shared
// open global.Elmish
// open System
// open Thoth.Fetch
// open Thoth.Json
// open Fetch.Types
open Feliz
// open Feliz.MaterialUI
// open Fable.MaterialUI.Icons
// open Fable.MaterialUI.MaterialDesignIcons
// open Feliz.UseElmish
// open Fable.Core.Experimental
// open System.Text.RegularExpressions
// open Fable.Core.JS

[<ReactComponent>]
let view = React.functionComponent (fun (inputProps: {| parentModel : Shared.LoggedInModel; parentDispatch : (Shared.Msg -> unit) |}) ->
  let classes = Styles.useStyles ()
  Html.text "Welcome"
)
